import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FileAttachment } from 'entities/feedback-input';
import { ToastType } from 'entities/toast-type';
import { ToastService } from 'services/toast.service';

@Component({
    selector: 'app-feedback-attachments',
    imports: [CommonModule],
    templateUrl: './add-attachments.component.html'
})
export class AddAttachmentsComponent implements AfterViewInit {
  toastService = inject(ToastService);
  activeModal = inject(NgbActiveModal);
  attachments: FileAttachment[] = [];
  @Input() mode: "single" | "multiple" = "multiple";
  @Input() alreadyAddedQty: number = 0;

  ngAfterViewInit(): void {
    this.attachments.push(new FileAttachment());
  }

  addFile(): void {
    if(this.mode === "multiple") {
      if (this.attachments.length === 5 || (this.alreadyAddedQty + this.attachments.length === 5)) {
        this.toastService.showToast('No more than 5 files can be attached', ToastType.Warning);
        return;
      }
      this.attachments.push(new FileAttachment());
    }
  }

  attachFiles(): void {
    const attachments = this.attachments.filter((x: FileAttachment) => x.name);
    if (!attachments.length) {
      return;
    }

    this.activeModal.close(attachments);
  }

  fileChanged(files: FileList, attachment: FileAttachment): void {
    const file: File = files[0];
    if (!file) {
      return;
    }

    const item = this.attachments.find((x: FileAttachment) => x.name === file.name);
    if (item) {
      this.toastService.showToast('File already attached', ToastType.Warning);
      return;
    }

    if (file.size > 2097152) {
      this.toastService.showToast(
        `File with size greater than 2MB cannot be uploaded.`,
        ToastType.Error
      );
      return;
    }

    attachment.name = file.name;
    attachment.size = ""+file.size;
    attachment.mimeType = file.type;
    this.convertToBase64(file, attachment);
  }

  closeModal(): void {
    this.activeModal.dismiss();
  }

  convertToBase64(file: File, attachment: FileAttachment) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const base64WithHeader = e.target.result.split(',');
      attachment.base64File = base64WithHeader[1];
    };
    reader.onerror = (error) => {
      console.error('Error: ', error);
    };
    reader.readAsDataURL(file);
  }
}
